import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchService'
})
export class SearchServicePipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it.service_name.toLowerCase().includes(searchText);
    });
  }

}
